var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',[_c('thead',[_c('TableRow',[(_vm.$slots.headers)?_vm._t("headers"):_vm._e()],2)],1),_c('tbody',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }